import React, { useState } from 'react';
import { Tooltip, Button, Icon, message } from 'antd';
import { FaRegFileAlt } from 'react-icons/fa';
import cn from 'classnames';
import { useFetchReportSummaryData } from '../../../../api/reportSummaryData';
import { createUrlFromBase64 } from '../../../../../../helpers/attachments/createUrlFromBase64';
import { downloadAttachment } from '../../../../../../helpers/attachments/downloadAttachment';
import styles from './index.module.scss';

const DownloadSummaryReport = ({ acceptanceId, houseId, className }) => {
  const [loading, setLoading] = useState(false);

  const fetchReport = useFetchReportSummaryData();

  const handleClick = async (e) => {
    e.stopPropagation();

    setLoading(true);

    const result = await fetchReport({ acceptanceId, houseId });

    setLoading(false);

    if (result === 'Error') {
      return;
    }

    if (!result.success) {
      message.error(
        result.message ?? 'Не удалось получить файл со сводными данными'
      );
      return;
    }

    const { data, fileName: title } = result.data;
    const { value: url, removeUrl } = createUrlFromBase64(data);
    downloadAttachment({ url, title });
    removeUrl();
  };

  return (
    <Tooltip
      title={
        houseId
          ? 'Скачать «Сводные данные» по дому'
          : 'Скачать «Сводные данные» по всей приемке'
      }
      getPopupContainer={getPopupContainer}
    >
      <Button
        className={cn(styles.root, className, { [styles.disabled]: loading })}
        onClick={handleClick}
      >
        {loading ? <Icon type="loading" /> : <Icon component={FaRegFileAlt} />}
      </Button>
    </Tooltip>
  );
};

export default DownloadSummaryReport;

function getPopupContainer(trigger) {
  return trigger.parentNode;
}
